export const TOGGLE_SOURCE_PLAY = "toggleSourcePlay";
export const SET_SOURCE_PLAY = "setSourcePlay";
export const TOGGLE_RECORD_PLAY = "toggleRecordPlay";
export const UPDATE_POSITION = "updatePosition";
export const SET_RECORD_PLAY = "setRecordPlay";
export const SET_SOURCE_VOLUME = "setSourceVolume";
export const SET_RECORD_VOLUME = "setRecordVolume";
// export const STOP_SOURCE_PLAY_AND_CONTINUE = "stopSourcePlayAndContinue";
// export const STOP_RECORDING_AND_CONTINUE = "stopRecordingAndContinue";
export const TOGGLE_LESSON_PLAY = "toggleLessonPlay";
export const STOP_ALL = "stopAll";
export const STOP_RECORD_PLAY_AND_CONTINUE = "stopRecordAndContinue";
export const STOP_SOURCE_PLAY = "stopSourcePlay";
export const SET_RECORDING = "setRecording";
export const STOP_RECORD_PLAY = "stopRecordPlay";
export const START_SOURCE_PLAY = "startRecordPlay";
export const TOGGLE_NEW_LESSON_SOURCE ='newLessonSourceToggle';